import React, { createContext, useContext, ReactNode } from "react";
import { useNotifications } from "hooks/useNotifications";

interface NotificationContextType {
  notifications: ReturnType<typeof useNotifications>["notifications"];
  removeNotification: ReturnType<typeof useNotifications>["removeNotification"];
  clearAllNotifications: ReturnType<typeof useNotifications>["clearAllNotifications"];
  hasNotifications: ReturnType<typeof useNotifications>["hasNotifications"];
  notificationCount: ReturnType<typeof useNotifications>["notificationCount"];
  isLoading: ReturnType<typeof useNotifications>["isLoading"];
  error: ReturnType<typeof useNotifications>["error"];
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

interface NotificationProviderProps {
  children: ReactNode;
  enabled?: boolean;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children, enabled = true }) => {
  const notificationData = useNotifications({ enabled });

  return <NotificationContext.Provider value={notificationData}>{children}</NotificationContext.Provider>;
};

export const useNotificationContext = (): NotificationContextType => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotificationContext must be used within a NotificationProvider");
  }
  return context;
};
